import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../store/languageContext';
import { LanguageFactory, LocalPersistence } from '../../../factories';
import { Tabs, Form, message, Card, Steps, Button } from 'antd';
import ActionButtonsBar from '../../ui/ActionButtonsBar'
import PageContainer from '../../PageContainer';
import { addGuestRoom} from '../../../services/guestrooms'
import RoomType from './RoomType';
import Images from './Images';
import Amenities from './Amenities';
import Loading from '../../Loading';
import UniqueRoomAmenitie from './uniqueRoomAmenities';

const { TabPane } = Tabs;

const { Step } = Steps;
interface propsTypes {
    isEditable?: void | any,
    cancelEditable?: void | any,
    setOperation?: void | any
    operationFlag?: any
    setCurrentRow?: void | any
    currentRow?: any
    setDefaultTabKey?: (a: string) => void
    defKey?: string
    setDefKey: (e: string) => void
    singleAmenity?: string
    setSingleAmenity?: (e: string) => void
}

const GuestRoomsComponents = (props: propsTypes) => {
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const [form] = Form.useForm();
    const [addLoading, setAddLoading] = useState<boolean>(false)
    const [disabledStatus, setDisabledStatus] = useState(true)
    const [amenitieSelectTags] = useState([[]]);
    const [tabSelected, setTabSelected] = useState<string>('')
    const [amenitiesToAdd, setAmenitiesToAdd] = useState<object[]>([])
    const [current, setCurrent] = useState(0);
    const [roomId, setRoomId] = useState<number>(0)
    const [roomData, setRoomData] = useState([])
    const [roomLangId, setRoomLangId] = useState(0)

    const { Step } = Steps;

    const next = () => {
      setCurrent(current + 1);
    };
  
    const prev = () => {
      setCurrent(current - 1);
    };

    const changeTab = (key: string) => {
        setTabSelected(key)
    }
    useEffect(() => {
        props.operationFlag === 'edit' || props.operationFlag === 'add' ? props.isEditable(true) : props.cancelEditable(false)
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.operationFlag])

    const addOnFinish = () => {
        form.validateFields().then(async (value: any) => {
            const get_session = new LocalPersistence('session')
            const session: any = await get_session.getSessionPersistence()
            setAddLoading(true) 
            
            if (value?.amenities) {
                // 
                Object.keys(value?.amenities).forEach((item: string, k: number) => {
                    if (amenitieSelectTags[parseInt(item)] && value.amenities[item]) {
                        value.amenities[item].tags = amenitieSelectTags[parseInt(item)].join(' | ')
                    } else if (value.amenities[item]) {
                    value.amenities[item].tags = ''
                    }
                })
                let arr = value.amenities.filter((aments: object | undefined, idx: number) => {
                   return  aments !== undefined
                });
                value.amenities=[...arr];
            }
            value.amenities = amenitiesToAdd

            const params = {
                "supplier": session.supplier,
                "propertyId": session.propertyId,
                "property": {
                    "guestrooms": {
                        "guestroom": [
                            { ...value }
                        ]
                    }
                }
            }
            
             addGuestRoom(params).then(
                 response => {
                     if (response.result.success) {
                         setAddLoading(false)
                         // props.setOperation('table')
                         const { guestrooms: { guestroom: [{ id: grid }] } } = params.property
                         const [filtered] = response.property?.guestrooms.guestroom.filter(({ id } : { id: number }) => id === grid)
                         setRoomId(filtered.grid)
                         setRoomLangId(filtered.grlangid)
                         setRoomData(filtered)
                         next()
                     } else {
                         setAddLoading(false)
                         message.error({
                               content: response?.errors[0]?.message,
                         });
                     }
                   
                 },err=>{
                     setAddLoading(false)
                     message.error({
                         content: err?.message || err?.errors[0]?.message
                     });
                   
                 }
             )
          
        })
    };

    const addCancelClik = () => {
         props.setOperation('table')
    }

    const addValidateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields().then(() => {
            setDisabledStatus(false)
        }).catch(() => {
            let savelock = false
            let s = form?.getFieldsError()
            for (let i = 0; i < s.length; i++) {
                if (s[i].errors.length) {
                    savelock = true;
                    break
                }
            }
            setDisabledStatus(savelock)
        })
    }

    const steps = [
      {
        title: 'Room Type',
      },
      {
        title: 'Amenities',
      },
      {
        title: 'Unique Room Amenities',
      },
    ];

    const stepsEdition = [
      {
        title: 'Room Type',
      },
      {
        title: 'Images',
      },
      {
        title: 'Amenities',
      },
      {
        title: 'Unique Room Amenities',
      },
    ];

    const renderStepsButtons = () => {
      const stepsData = props.operationFlag === 'add' ? steps : stepsEdition
      return (
        <div
          className="steps-action action-buttons-bar"
          style={{ 
            left: window.rightContentWidth, 
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <div>
            {current > 0 && props.operationFlag !== 'add' && (
              <Button type="link" style={{ margin: '0 8px' }} onClick={() => prev()}>
                Previous
              </Button>
            )}
          </div>
          <div>
            {current < stepsData.length - 1 && props.operationFlag !== 'add' &&  (
              <Button type="link" style={{ margin: '0 20px' }} onClick={() => next()}>
                Skip
              </Button>
            )}
            {current <= stepsData.length - 1 && (
              <Button style={{ margin: '0 10px' }} onClick={() => props.setOperation('table')}>
                Cancel
              </Button>
            )}
            {current < stepsData.length - 1 &&  (
              <Button
                style={{ margin: '0 10px' }} 
                type="primary" 
                onClick={() => next()}
                disabled={props.operationFlag === 'add' && current === 0}
              >
                Next
              </Button>
            )}
            {current === stepsData.length - 1 && (
              <Button style={{ margin: '0 10px' }} type="primary" onClick={() => {
                message.success('Processing complete!')
                props.setOperation('table')
              }}>
                Done
              </Button>
            )}
          </div>
        </div>
    )}

    const onChangeStep = (value: number) => {
      setCurrent(value);
    };

    if (addLoading) return <Loading type={'large'} />
    return props.operationFlag === 'add' ? (
      <PageContainer>
      <Card>
        <Form
          layout='vertical'
          form={form}
          name='basic'
          onValuesChange={addValidateFieldsError}>
          <div style={{ backgroundColor: '#fff' }}>
            <Steps
              type="navigation"
              current={current}
              className="site-navigation-steps"
            >
              {steps.map(item => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
              <div className="steps-content">
                {
                  (current === 0 && 
                    <RoomType
                      isEditable={props.isEditable}
                      cancelEditable={props.cancelEditable}
                      operationFlag={props.operationFlag}
                      setOperation={props.setOperation}
                      currentRow={props.currentRow}
                      setCurrentRow={props.setCurrentRow}
                      addValidateFieldsError={addValidateFieldsError}
                      currentForm={form}
                    />) ||
                  (current === 1 && 
                    <Amenities
                      isNewRecordRoom={true}
                      operationFlag={props.operationFlag}
                      setOperation={props.setOperation}
                      currentRow={props.currentRow}
                      setCurrentRow={props.setCurrentRow}
                      setAmenitiesToAdd={setAmenitiesToAdd}
                      setDefKey={props.setDefKey}
                      stay={true}
                      roomId={roomId}
                      roomLangId={roomLangId}
                    />) ||
                  (current === 2 && 
                    <UniqueRoomAmenitie
                      setOperation={props.setOperation}
                      currentRow={props.currentRow}
                      roomData={roomData}
                      roomId={roomId}
                      roomLangId={roomLangId}
                    />)
                }
              </div>
            </div>
          </Form>
          {current === 0 && <div className="roomType-add">
            <ActionButtonsBar
              // onCancel={addCancelClik}
              onSave={addOnFinish}
              disabledSave={disabledStatus}
            />
          </div>}
          { renderStepsButtons() }
        </Card>
      </PageContainer>   
    ) : (
      <div style={{ backgroundColor: '#fff' }}>
       <Steps
        type="navigation"
        current={current}
        onChange={onChangeStep}
        className="site-navigation-steps"
        >
          {stepsEdition.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className="steps-content">
          {
            (current === 0 && 
            <RoomType
              isEditable={props.isEditable}
              cancelEditable={props.cancelEditable}
              operationFlag={props.operationFlag}
              setOperation={props.setOperation}
              currentRow={props.currentRow}
              setCurrentRow={props.setCurrentRow}
            />) ||
            (current === 1 &&
              <Images
                isEditable={props.isEditable}
                cancelEditable={props.cancelEditable}
                operationFlag={props.operationFlag}
                setOperation={props.setOperation}
                currentRow={props.currentRow}
                setCurrentRow={props.setCurrentRow}
              />
            ) ||
            (current === 2 && 
              <Amenities
              isNewRecordRoom={false}
              setOperation={props.setOperation}
              currentRow={props.currentRow}
              setCurrentRow={props.setCurrentRow}
              singleAmenity={props.singleAmenity}
              setDefKey={props.setDefKey}
            />) ||
            (current === 3 && 
              <UniqueRoomAmenitie
              setOperation={props.setOperation}
              currentRow={props.currentRow}
            />)
          }
        </div>
        { renderStepsButtons() }
       </div>
    )
}

export default GuestRoomsComponents;

